import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URLS } from 'src/app/app-url.constant';
import { CommonService } from '../common/common.service';
import { UploadDocumentClassId } from 'src/app/components/shared/commonData';

@Injectable({
  providedIn: 'root',
})
export class SupplierAssessmentService {
  constructor(
    private http: HttpClient,
    private commonSvc: CommonService,
    private uploadDocumentClassId: UploadDocumentClassId
  ) {}

  getSupplierCategories() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.GetSupplierCategory}`
    );
  }

  getSupplierStatusList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.GetAllSupplierApplicationStatusMaster}`
    );
  }
  getAllSupplierTypeMaster() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.GetAllSupplierTypeMaster}`
    );
  }

  getSupplierList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.GetAllSupplierList}`
    );
  }

  getQuestionerCategoryList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.GetAllSupplierQuestionCategoryMaster}`
    );
  }

  GetAllSupplierQuestions() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.GetAllSupplierQuestions}`
    );
  }

  GetConfigurationValue(requestBodyData: any) {
    let requestBody: any = this.generateRequestBody(requestBodyData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.GetConfigurationValue}`,
      requestBody
    );
  }

  GetSupplierRemarkList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.GetSupplierRemarkList}`
    );
  }

  GetAllDocumentType() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.GetAllDocumentType}`
    );
  }

  getAllQuestionList() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.GetAllSupplierQuestionMaster}`
    );
  }

  AddQuestionnaireDocument(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.AddQuestionnaireDocument}`,
      requestBody
    );
  }

  DeleteQuestionnaireDocument(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.DeleteQuestionnaireDocument}`,
      requestBody
    );
  }

  DeleteQuestionnaireSingleDocument(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.DeleteQuestionnaireSingleDocument}`,
      requestBody
    );
  }

  LogEmailRequestSupplierQuestionnaire(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.LogEmailRequestSupplierQuestionnaire}`,
      requestBody
    );
  }

  GetSupplierListById(supplierId: number) {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.GetSupplierListById}?Id=${supplierId}`
    );
  }

  GetSupplierAllQuestionTxn(supplierId: number) {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.GetSupplierAllQuestionTxn}?SupplierId=${supplierId}`
    );
  }

  SaveSupplierDetails(form: any) {
    const requestBody = {
      requestUserLoginName: JSON.parse(localStorage.getItem('userData')!)
        ?.username,
      requestId: '',
      data: {
        supplierTypeId: form.userType,
        actionOwnerId: form.actionOwner,
        actionReviewerId: form.actionReviewer,
        legalName: form.name,
        countryId: form.country,
        stateId: form.state,
        // cityId: form.city,
        originId: form.city,
        email: form.email,
        mobile: form.contactNumber,
        photo: form.profile,
        mobileCountryId: form.country,
        applicationStatusId: null,
        details: '',
        riskScore: 0,
        supplierCategoryId: form.supplierCategory,
      },
    };

    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.AddSupplierlist}`,
      requestBody
    );
  }

  UpdateSupplierQuestionAnswer(requestBody: any) {
    return this.http.put(
      `${URLS.baseApiHostUrl}${URLS.SupplierAnonymous.endpoint}${URLS.SupplierAnonymous.methods.UpdateSupplierQuestionAnswer}`,
      requestBody
    );
  }

  updateSupplierApplicationStatus(supplierId: Number, applicationID: Number) {
    const requestBody = {
      requestUserLoginName: this.commonSvc.getReqLoginUserName(),
      requestId: '',
      data: {
        supplierId: supplierId,
        applicationStatusId: applicationID,
      },
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.UpdateSupplierApplicationStatus}`,
      requestBody
    );
  }
  updateSupplierdetails(
    supplierid: string,
    supplierdetails: any,
    oldprofile: any,
    factoryFileArray: [],
    certificateFileArray: [],
    declarationFileArray: [],
    auditInternalFileArray: [],
    auditThirdPartyFileArray: [],
    supplierSpocId: string
  ) {
    console.log(supplierdetails);

    const formdata = new FormData();
    formdata.append('Id', JSON.parse(supplierid)),
      formdata.append('SupplierTypeId', supplierdetails?.supplierType),
      formdata.append('SupplierType', ''), //hardcoded
      formdata.append('ActionOwnerId', supplierdetails?.actionOwner),
      formdata.append('ActionReviewerId', supplierdetails?.actionReviewer),
      formdata.append('LegalName', supplierdetails?.supplierName),
      formdata.append('OriginId', '1'), //hardcoded
      formdata.append('Origin', '1'), //hardcoded
      formdata.append('Email', supplierdetails?.email),
      formdata.append('MobileCountryId', supplierdetails?.mobileCountryId),
      formdata.append('Mobile', supplierdetails?.contactNumber),
      formdata.append('Photo', oldprofile),
      formdata.append(
        'PhotoNew',
        supplierdetails?.profile ? supplierdetails.profile : ''
      ),
      formdata.append(
        'DocumentClassId',
        this.uploadDocumentClassId.SupplierPhoto.toString()
      ),
      formdata.append('IsSingleFile', 'true'),
      formdata.append(
        'DocumentGroupId',
        supplierdetails.documentGroupId ? supplierdetails.documentGroupId : ''
      ),
      formdata.append('ApplicationStatusId', '0'), //hardcoded
      formdata.append('Details', supplierdetails?.sustanabilityJourney),
      formdata.append('RiskScore', '1'), //hardcoded
      formdata.append('CountryId', supplierdetails?.country),
      formdata.append('StateId', supplierdetails?.state),
      formdata.append('SupplierCategoryId', supplierdetails?.supplierCategory),
      formdata.append('Addressline1', supplierdetails?.addressline1),
      formdata.append('Addressline2', supplierdetails?.addressline2),
      formdata.append(
        'HaveYouStartedJourney',
        ![true, false]?.includes(supplierdetails?.haveYouStartedJourney)
          ? ''
          : supplierdetails?.haveYouStartedJourney
      ),
      formdata.append('Remark', supplierdetails?.remark),
      formdata.append(
        'CertificateComment',
        supplierdetails?.certificateComment
      ),
      formdata.append(
        'DeclarationsComment',
        supplierdetails?.declarationsComment
      ),
      formdata.append(
        'InternalAuditComment',
        supplierdetails?.internalAuditComment
      ),
      formdata.append(
        'ThirdPartyAuditComment',
        supplierdetails?.thirdPartyAuditComment
      ),
      formdata.append('ActionOwnerName', supplierdetails?.actionOwnerd),
      formdata.append('ActionReviewerName', supplierdetails?.actionReviewerd),
      formdata.append('IndustryType', supplierdetails?.industryType),
      formdata.append(
        'NoOfworkers',
        supplierdetails?.noofWorkers ? supplierdetails?.noofWorkers : ''
      ),
      formdata.append('CityName', supplierdetails?.city),
      formdata.append('ZipCode', supplierdetails?.zipCode),
      formdata.append(
        'SupplierDocumentFactoryLicenseDTO.SupplierId',
        JSON.parse(supplierid)
      ),
      formdata.append(
        'SupplierDocumentFactoryLicenseDTO.DocumentCategory',
        '1'
      ),
      formdata.append(
        'SupplierDocumentFactoryLicenseDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierFactoryLicense.toString()
      ),
      formdata.append(
        'SupplierDocumentFactoryLicenseDTO.IsSingleFile',
        'false'
      ),
      formdata.append(
        'SupplierDocumentCertificateDTO.SupplierId',
        JSON.parse(supplierid)
      ),
      formdata.append('SupplierDocumentCertificateDTO.DocumentCategory', '2'),
      formdata.append(
        'SupplierDocumentCertificateDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierCertificates.toString()
      ),
      formdata.append('SupplierDocumentCertificateDTO.IsSingleFile', 'false'),
      formdata.append(
        'SupplierDocumentDeclarationsDTO.SupplierId',
        JSON.parse(supplierid)
      ),
      formdata.append('SupplierDocumentDeclarationsDTO.DocumentCategory', '3'),
      formdata.append(
        'SupplierDocumentDeclarationsDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierFactoryLicenseDeclarations.toString()
      ),
      formdata.append('SupplierDocumentDeclarationsDTO.IsSingleFile', 'false'),
      formdata.append(
        'SupplierDocumentAuditDTO.SupplierId',
        JSON.parse(supplierid)
      ),
      formdata.append('SupplierDocumentAuditDTO.DocumentCategory', '4'),
      formdata.append(
        'SupplierDocumentAuditDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierFactoryAuditInternal.toString()
      ),
      formdata.append('SupplierDocumentAuditDTO.IsSingleFile', 'false'),
      formdata.append(
        'SupplierDocumentThirdPartyAuditDTO.SupplierId',
        JSON.parse(supplierid)
      ),
      formdata.append(
        'SupplierDocumentThirdPartyAuditDTO.DocumentCategory',
        '5'
      );
    formdata.append(
      'SupplierDocumentThirdPartyAuditDTO.DocumentClassId',
      this.uploadDocumentClassId.SupplierFactoryAuditThirdParty.toString()
    ),
      formdata.append(
        'SupplierDocumentThirdPartyAuditDTO.IsSingleFile',
        'false'
      ),
      formdata.append(
        'BusinessProportion',
        supplierdetails?.businessProportion
          ? supplierdetails?.businessProportion
          : ''
      );
    formdata.append(
      'StrategicValue',
      supplierdetails?.strategicValue ? supplierdetails?.strategicValue : ''
    );
    formdata.append(
      'Tenure',
      supplierdetails?.tenure ? supplierdetails?.tenure : ''
    );
    formdata.append(
      'IsHighBrandValue',
      supplierdetails?.isHighBrandValue ? supplierdetails?.isHighBrandValue : ''
    );

    // formdata.append('SupplierSpoc.Id',),
    if (
      supplierdetails?.spocName ||
      supplierdetails?.spocGender ||
      supplierdetails?.spocEmail ||
      supplierdetails?.phoneNoSpocCode ||
      supplierdetails?.phoneNoSpoc
    ) {
      formdata.append('SupplierSpoc.SupplierId', JSON.parse(supplierid)),
        formdata.append('SupplierSpoc.Name', supplierdetails?.spocName),
        formdata.append('SupplierSpoc.Gender', supplierdetails?.spocGender),
        formdata.append(
          'SupplierSpoc.Email',
          supplierdetails?.spocEmail ? supplierdetails?.spocEmail : ''
        ),
        formdata.append(
          'SupplierSpoc.PhoneNoCountryId',
          supplierdetails?.phoneNoSpocCode
        ),
        formdata.append(
          'SupplierSpoc.PhoneNo',
          supplierdetails?.phoneNoSpoc ? supplierdetails?.phoneNoSpoc : ''
        );
      formdata.append(
        'SupplierSpoc.SupplierSpocId',
        supplierSpocId ? JSON.parse(supplierSpocId) : ''
      );
    }

    var data: any = [];
    supplierdetails?.owners.forEach((res: any) => {
      const obj = {
        id: res.id, // hardcoded
        isOwnerOrSpoc: true,
        supplierId: JSON.parse(supplierid),
        name: res.ownerName,
        gender: res.gender ? parseInt(res.gender) : null,
        email: res.owneremail ?? null,
        phoneNoCountryId: res.phoneNoOdc
          ? JSON.stringify(res.phoneNoOdc)
          : null,
        phoneNo: res.phoneNoOd ?? null,
        address: res.address,
      };

      const keysToSkip = ['id', 'isOwnerOrSpoc', 'supplierId'];

      const hasUserData = Object.entries(obj).some(
        ([key, value]) =>
          !keysToSkip.includes(key) &&
          value !== null &&
          value !== undefined &&
          value !== '' &&
          value !== '""'
      );

      if (hasUserData) {
        data.push(obj);
      }
    });
    formdata.append('SupplierOwner', JSON.stringify(data));

    factoryFileArray.forEach((res: any) => {
      if (res instanceof File) {
        formdata.append('SupplierDocumentFactoryLicenseDTO.FilePath', res);
      }
    });

    certificateFileArray.forEach((res: any) => {
      if (res instanceof File) {
        formdata.append('SupplierDocumentCertificateDTO.FilePath', res);
      }
    });

    declarationFileArray.forEach((res: any) => {
      if (res instanceof File) {
        formdata.append('SupplierDocumentDeclarationsDTO.FilePath', res);
      }
    });

    auditInternalFileArray.forEach((res: any) => {
      if (res instanceof File) {
        formdata.append('SupplierDocumentAuditDTO.FilePath', res);
      }
    });

    auditThirdPartyFileArray.forEach((res: any) => {
      if (res instanceof File) {
        formdata.append('SupplierDocumentThirdPartyAuditDTO.FilePath', res);
      }
    });

    return this.http.put(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.UpdateSupplierlist}?userLoginName=${this.commonSvc.getReqLoginUserName()}`,
      formdata
    );
  }

  checkMailExist(email: string) {
    const requestBody = {
      requestUserLoginName: this.commonSvc.getReqLoginUserName(),
      requestId: '',
      data: email,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.IsAnExistingEmail}`,
      requestBody
    );
  }

  checkMobileExist(mobileNo: Number) {
    const requestBody = {
      requestUserLoginName: this.commonSvc.getReqLoginUserName(),
      requestId: '',
      data: mobileNo,
    };
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.IsAnExistingContact}`,
      requestBody
    );
  }

  downloadExcelTemplateForSupplier() {
    return this.http.get(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.DownloadExcelTemplateforSupplier}`,
      { responseType: 'blob' }
    );
  }

  uploadExcelForSupplier(requestBody: any) {
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.UploadExcelForSupplier}`,
      requestBody
    );
  }

  addSupplierlist(
    formDetails: any,
    factoryFileArray: [],
    certificateFileArray: [],
    declarationFileArray: [],
    auditInternalFileArray: [],
    auditThirdPartyFileArray: []
  ) {
    console.log(formDetails);

    const formdata = new FormData();
    formdata.append(
      'requestUserLoginName',
      this.commonSvc.getReqLoginUserName()
    );
    formdata.append('requestId', '');
    formdata.append('message', '');
    formdata.append('data.SupplierTypeId', formDetails?.supplierType);
    formdata.append('data.ActionOwnerId', formDetails?.actionOwner);
    formdata.append('data.ActionReviewerId', formDetails?.actionReviewer);

    formdata.append('data.ActionOwnerName', formDetails?.actionOwnerd),
      formdata.append('data.ActionReviewerName', formDetails?.actionReviewerd),
      formdata.append('data.LegalName', formDetails?.supplierName);
    formdata.append('data.OriginId', '1'); //hardcoded
    formdata.append('data.SupplierId', '0'); //hardcoded
    formdata.append('data.Email', formDetails?.email);
    formdata.append('data.MobileCountryId', formDetails?.mobileCountryId);
    formdata.append('data.Mobile', formDetails?.contactNumber);
    formdata.append('data.Photo', formDetails?.profile);
    formdata.append(
      'data.DocumentClassId',
      this.uploadDocumentClassId.SupplierPhoto.toString()
    ),
      formdata.append('data.IsSingleFile', 'true'),
      formdata.append(
        'data.DocumentGroupId',
        formDetails.documentGroupId ? formDetails.documentGroupId : ''
      ),
      formdata.append('data.ApplicationStatusId', '1'); //hardcoded
    // formdata.append('data.Details',);
    formdata.append('data.RiskScore', '0'); //hardcoded
    formdata.append('data.CountryId', formDetails?.country);
    formdata.append('data.StateId', formDetails?.state);
    formdata.append('data.SupplierCategoryId', formDetails?.supplierCategory),
      formdata.append('data.Addressline1', formDetails?.addressline1),
      formdata.append('data.Addressline2', formDetails?.addressline2),
      formdata.append(
        'data.HaveYouStartedJourney',
        ![true, false]?.includes(formDetails?.haveYouStartedJourney)
          ? ''
          : formDetails?.haveYouStartedJourney
      ),
      formdata.append('data.Remark', formDetails?.remark),
      formdata.append(
        'data.CertificateComment',
        formDetails?.certificateComment
      ),
      formdata.append(
        'data.DeclarationsComment',
        formDetails?.declarationsComment
      ),
      formdata.append(
        'data.InternalAuditComment',
        formDetails?.internalAuditComment
      ),
      formdata.append(
        'data.ThirdPartyAuditComment',
        formDetails?.thirdPartyAuditComment
      ),
      formdata.append('data.IndustryType', formDetails?.industryType),
      formdata.append(
        'data.NoOfworkers',
        formDetails?.noofWorkers ? formDetails?.noofWorkers : ''
      ),
      formdata.append('data.CityId', formDetails?.city),
      formdata.append('data.ZipCode', formDetails?.zipCode);

    formdata.append(
      'data.BusinessProportion',
      formDetails?.businessProportion ? formDetails?.businessProportion : ''
    );
    formdata.append(
      'data.StrategicValue',
      formDetails?.strategicValue ? formDetails?.strategicValue : ''
    );
    formdata.append(
      'data.Tenure',
      formDetails?.tenure ? formDetails?.tenure : ''
    );
    formdata.append(
      'data.IsHighBrandValue',
      formDetails?.isHighBrandValue ? formDetails?.isHighBrandValue : ''
    );

    if (
      formDetails?.spocName ||
      formDetails?.spocGender ||
      formDetails?.spocEmail ||
      formDetails?.phoneNoSpocCode ||
      formDetails?.phoneNoSpoc
    ) {
      formdata.append('data.SupplierSpoc.Name', formDetails?.spocName),
        formdata.append('data.SupplierSpoc.Gender', formDetails?.spocGender),
        formdata.append(
          'data.SupplierSpoc.Email',
          formDetails?.spocEmail ? formDetails?.spocEmail : ''
        ),
        formdata.append(
          'data.SupplierSpoc.PhoneNoCountryId',
          formDetails?.phoneNoSpocCode
        ),
        formdata.append('data.SupplierSpoc.PhoneNo', formDetails?.phoneNoSpoc);

      formdata.append('data.SupplierSpoc.IsOwnerOrSpoc', 'true'); //hardcoded
      formdata.append('data.SupplierSpoc.Id', '0'); //hardcoded
      formdata.append('data.SupplierSpoc.SupplierId', '0'); //hardcoded
    }

    formdata.append(
      'data.AddSupplierDocumentFactoryLicenseDTO.DocumentCategory',
      '1'
    ),
      formdata.append(
        'data.AddSupplierDocumentFactoryLicenseDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierFactoryLicense.toString()
      ),
      formdata.append(
        'data.AddSupplierDocumentFactoryLicenseDTO.IsSingleFile',
        'false'
      ),
      formdata.append(
        'data.AddSupplierDocumentCertificateDTO.DocumentCategory',
        '2'
      ),
      formdata.append(
        'data.AddSupplierDocumentCertificateDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierCertificates.toString()
      ),
      formdata.append(
        'data.AddSupplierDocumentCertificateDTO.IsSingleFile',
        'false'
      ),
      formdata.append(
        'data.AddSupplierDocumentDeclarationsDTO.DocumentCategory',
        '3'
      ),
      formdata.append(
        'data.AddSupplierDocumentDeclarationsDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierFactoryLicenseDeclarations.toString()
      ),
      formdata.append(
        'data.AddSupplierDocumentDeclarationsDTO.IsSingleFile',
        'false'
      ),
      formdata.append('data.AddSupplierDocumentAuditDTO.DocumentCategory', '4'),
      formdata.append(
        'data.AddSupplierDocumentAuditDTO.DocumentClassId',
        this.uploadDocumentClassId.SupplierFactoryAuditInternal.toString()
      ),
      formdata.append('data.AddSupplierDocumentAuditDTO.IsSingleFile', 'false'),
      formdata.append(
        'data.AddSupplierDocumentThirdPartyAuditDTO.DocumentCategory',
        '5'
      );
    formdata.append(
      'data.AddSupplierDocumentThirdPartyAuditDTO.DocumentClassId',
      this.uploadDocumentClassId.SupplierFactoryAuditThirdParty.toString()
    ),
      formdata.append(
        'data.AddSupplierDocumentThirdPartyAuditDTO.IsSingleFile',
        'false'
      ),
      formdata.append('data.Details', formDetails?.sustanabilityJourney);

    if (factoryFileArray.length > 0) {
      factoryFileArray.forEach((file: any) => {
        formdata.append(
          'data.AddSupplierDocumentFactoryLicenseDTO.FilePath',
          file
        );
      });
    }

    if (certificateFileArray.length > 0) {
      certificateFileArray.forEach((file: any) => {
        formdata.append(
          'data.AddSupplierDocumentCertificateDTO.FilePath',
          file
        );
      });
    }

    if (declarationFileArray.length > 0) {
      declarationFileArray.forEach((file: any) => {
        formdata.append(
          'data.AddSupplierDocumentDeclarationsDTO.FilePath',
          file
        );
      });
    }

    if (auditInternalFileArray.length > 0) {
      auditInternalFileArray.forEach((file: any) => {
        formdata.append('data.AddSupplierDocumentAuditDTO.FilePath', file);
      });
    }

    if (auditThirdPartyFileArray.length > 0) {
      auditThirdPartyFileArray.forEach((file: any) => {
        formdata.append(
          'data.AddSupplierDocumentThirdPartyAuditDTO.FilePath',
          file
        );
      });
    }

    var data: any = [];
    formDetails?.owners.forEach((res: any) => {
      const obj = {
        id: res.id, // hardcoded
        isOwnerOrSpoc: true,
        supplierId: 0,
        name: res.ownerName,
        gender: res.gender ? parseInt(res.gender) : '',
        email: res.owneremail,
        phoneNoCountryId: res.phoneNoOdc ? JSON.stringify(res.phoneNoOdc) : '',
        phoneNo: res.phoneNoOd,
        address: res.address,
      };

      const keysToSkip = ['id', 'isOwnerOrSpoc', 'supplierId'];

      const hasUserData = Object.entries(obj).some(
        ([key, value]) =>
          !keysToSkip.includes(key) &&
          value !== null &&
          value !== undefined &&
          value !== '' &&
          value !== '""'
      );

      if (hasUserData) {
        data.push(obj);
      }
    });

    formdata.append('data.SupplierOwner', JSON.stringify(data));
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.AddSupplierlist}`,
      formdata
    );
  }

  removeOwnerandSpoc(id: any) {
    const requestBody: any = {
      requestUserLoginName: this.commonSvc.getReqLoginUserName(),
      requestId: '',
      data: {
        id: id,
      },
      message: '',
    };

    return this.http.delete(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.RemoveSupplierOwnerAndSpoc}`,
      {
        body: requestBody,
      }
    );
  }

  RemoveSupplierDocument(id: any) {
    return this.http.delete(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.RemoveSupplierDocument}?documentId=${id}`
    );
  }

  testmultipleApi(array: any) {
    const formdata = new FormData();
    formdata.append('requestUserLoginName', 'abhishek'),
      formdata.append('requestId', '1'),
      formdata.append('data.SupplierId', '1'),
      formdata.append('DocumentCategory', '1'),
      formdata.append('message', 'testing');

    array.forEach((res: any) => {
      formdata.append('data.FilePath', res);
    });

    return this.http.post(
      `https://ztqm5jh7-7261.inc1.devtunnels.ms/API/Supplier/TestAddSupplierlist`,
      formdata
    );
  }
  generateRequestBody(data: any) {
    return {
      requestUserLoginName:
        JSON.parse(localStorage.getItem('userData')!)?.username || '',
      requestId: 'string',
      data: data,
      message: 'string',
    };
  }

  logBulkEmailRequestSupplierQuestionnaire(requestData: any) {
    let requestBody = this.generateRequestBody(requestData);
    return this.http.post(
      `${URLS.baseApiHostUrl}${URLS.Supplier.endpoint}${URLS.Supplier.methods.LogBulkEmailRequestSupplierQuestionnaire}`,
      requestBody
    );
  }
}